var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import MenuList from '@material-ui/core/MenuList/MenuList';
import Paper from '@material-ui/core/Paper/Paper';
import TextField from '@material-ui/core/TextField/TextField';
import Autocomplete from 'react-autocomplete';
import { debounce } from '../../helpers/utils';
import ComponentForm from '../ComponentForm';
/**
 * AutocompleteForm components
 */
var AutocompleteForm = /** @class */ (function (_super) {
    __extends(AutocompleteForm, _super);
    /**
     * Autocomplete constructor
     * @param props
     */
    function AutocompleteForm(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Return input template
         * @param props
         */
        _this.renderInput = function (props) {
            var inputProps = {
                'aria-autocomplete': props['aria-autocomplete'],
                'aria-expanded': props['aria-expanded'],
                'ref': props.ref,
            };
            var onFocus = function (evt) {
                props.onChange(evt);
                _this.props.onChange('keyValue', [_this.props.id, '']);
            };
            return React.createElement(TextField, { label: _this.props.label, fullWidth: true, margin: "normal", type: "search", role: props.role, onChange: props.onChange, onFocus: onFocus, onBlur: _this.onBlur, onClick: props.onClick, onKeyDown: props.onKeyDown, value: props.value, autoComplete: props.autoComplete, required: props.required, helperText: props.helperText, error: props.error, inputProps: inputProps });
        };
        /**
         * return menu list template
         * @param children
         */
        _this.renderMenu = function (children) {
            var content = children;
            if (_this.state.loading) {
                content = React.createElement(MenuItem, { style: { fontSize: 12 } }, "Chargement...");
            }
            else if (_this.state.noResult) {
                content = React.createElement(MenuItem, { style: { fontSize: 12 } },
                    "Aucun r\u00E9sultat trouv\u00E9 pour ",
                    _this.state.tmpValue);
            }
            else if (!children.length && typeof _this.state.noResult === 'undefined') {
                return React.createElement("div", null);
            }
            return (React.createElement(Paper, null,
                React.createElement(MenuList, null, content)));
        };
        /**
         * Handle input change
         * @param evt
         */
        _this.onChange = function (evt) { return __awaiter(_this, void 0, void 0, function () {
            var value;
            var _this = this;
            return __generator(this, function (_a) {
                if (this.cancel) {
                    this.cancel();
                }
                value = evt.target.value;
                this.setState({ tmpValue: value, displayValue: undefined, noResult: undefined, items: [] });
                if (!value || value === '') {
                    return [2 /*return*/];
                }
                if (value.length > 3) {
                    debounce(function () { return __awaiter(_this, void 0, void 0, function () {
                        var response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this.setState({ loading: true, open: true });
                                    return [4 /*yield*/, this.props.asyncOptions(value)];
                                case 1:
                                    response = _a.sent();
                                    if (!response.error) {
                                        this.setState({ items: response, loading: false, noResult: !response.length });
                                    }
                                    else {
                                        this.setState({ loading: false, noResult: undefined });
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); }, 250)();
                }
                return [2 /*return*/];
            });
        }); };
        /**
         * Handle click list item
         * @param value
         * @param item
         */
        _this.onSelect = function (value, item) {
            _this.setState({ displayValue: item.label, value: value, tmpValue: undefined }, function () {
                _this.props.onChange('keyValue', [_this.props.id, _this.state.value]);
            });
        };
        _this.onBlur = function () {
            setTimeout(function () {
                if (_this.state.displayValue || _this.state.displayValue !== '') {
                    _this.setState({ tmpValue: undefined, open: false });
                }
            }, 250);
        };
        _this.state = {
            displayValue: _this.props.initialValue && _this.props.initialValue.label ? _this.props.initialValue.label : undefined,
            items: [],
            loading: false,
            noResult: undefined,
            open: false,
            value: _this.props.initialValue && _this.props.initialValue.value ? _this.props.initialValue.value : undefined,
        };
        return _this;
    }
    AutocompleteForm.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        if (prevProps.reset !== this.props.reset && this.props.reset) {
            this.setState({ displayValue: '' });
            this.props.onChange('keyValue', [this.props.id, '']);
        }
    };
    /**
     * AutocompleteForm render method
     */
    AutocompleteForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, displayValue = _a.displayValue, items = _a.items, tmpValue = _a.tmpValue, open = _a.open;
        if (!this.props.visible) {
            return null;
        }
        var renderInput = function (props) {
            return _this.renderInput(__assign(__assign({}, props), { error: _this.props.error, helperText: _this.props.helperText, required: _this.props.required }));
        };
        return (React.createElement(Autocomplete, { wrapperStyle: { width: '100%' }, getItemValue: this.getItemValue, items: items, renderItem: this.renderItem, renderInput: renderInput, renderMenu: this.renderMenu, value: tmpValue || displayValue, onChange: this.onChange, onSelect: this.onSelect, selectOnBlur: true, open: open }));
    };
    /**
     * Return list item template
     * @param item
     */
    AutocompleteForm.prototype.renderItem = function (item) {
        return (React.createElement(MenuItem, { style: { fontSize: 12 }, key: item.value }, item.label));
    };
    /**
     * Return item label
     * @param item
     */
    AutocompleteForm.prototype.getItemValue = function (item) {
        return item.value;
    };
    return AutocompleteForm;
}(ComponentForm));
export default AutocompleteForm;
//# sourceMappingURL=AutocompleteForm.js.map